module.exports = __webpack_public_path__ + "media/images/application/template/icon--map-marker_yellow-c5cf13d7a4acb8f19805a9902d2ad2c1.svg";